export default class CompanyGroupConfiguration {
  constructor(
    public shouldConsiderInitialBalanceOnPredictedFlow: boolean,
    public considerSignature: boolean,
    public preNegotiationGenerateOurNumberErp: boolean,
  ) { }

  static make(data: any): CompanyGroupConfiguration {
    return new CompanyGroupConfiguration(
      data.should_consider_initial_balance_on_predicted_flow,
      data.consider_signature,
      data.pre_negotiation_generate_our_number_erp,
    );
  }
}
